module.exports = __webpack_public_path__ + "static/img/img13.df6416e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img13.png
// module id = p+XB
// module chunks = 1